var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-switcher",class:{'input-switcher--active': _vm.checked},on:{"click":function($event){return _vm.$emit('change', !_vm.checked)}}},[_c('div',{staticClass:"input-switcher__circle"})])}
var staticRenderFns = []

export { render, staticRenderFns }